import { render, staticRenderFns } from "./CreateWaitListItem.vue?vue&type=template&id=5d08e790&scoped=true&"
import script from "./CreateWaitListItem.vue?vue&type=script&lang=js&"
export * from "./CreateWaitListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d08e790",
  null
  
)

export default component.exports